/**
 * utils接口的统一出口
 */
let utils = {}
// 获取全部api文件
const utilsFiles = require.context(
  // 其api目录的相对路径
  './',
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /[\w-]+\.js$/
)

utilsFiles.keys().forEach(fileName => {
  // 获取util文件
  const util = utilsFiles(fileName)
  // 剥去文件名开头的 `./` 和结尾的扩展名
  const utilName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  if (utilName == 'index') return
  Object.keys(util).forEach(item => {
    utils[item] = util[item]
  })
})
export default utils



// WEBPACK FOOTER //
// ./src/utils/index.js